app.service('changePasswordView', function (validate, passwordInvalid) {

	function setElements() {
		$('.password-recovery-message a').addClass('js-password-recovery');
	}

	function setEvents() {
		passwordInvalid.init($('#password'), $('.password-invalid'), $('#password').closest('.row'), $('#email-hidden'));
		validate.task('changePassword');
	}

	function init() {
		setElements();
		setEvents();
	}

	return {
		init: init
	};
});